import React, { ReactNode } from "react";
import classNames from "classnames";
import { FiCheck } from "components/icons/FiCheck";
import { PendingCount } from "types/Models/Filing";

type StepProps = {
  isActive?: boolean;
  children: string;
  sectionKey: string;
  setActiveSectionKey: (sectionKey: string) => void;
  pendingCount?: PendingCount;
};

const StepPendingCount = ({ pending, total }: PendingCount) => {
  if (total === 0) {
    return null;
  }

  if (pending === 0) {
    return (
      <span
        className="t-flex t-h-4 t-w-4 t-shrink-0 t-items-center t-justify-center t-text-green-80"
        aria-label="All answered"
      >
        <FiCheck />
      </span>
    );
  }

  return (
    <span className="t-shrink-0 t-text-body-sm-lite t-text-neutral-50">
      {pending} left
    </span>
  );
};

const Step = ({
  children,
  isActive,
  sectionKey,
  setActiveSectionKey,
  pendingCount,
}: StepProps) => {
  return (
    <button
      className="all:unset t-group t-relative t-pl-1 t-max-w-full t-cursor-pointer t-select-none"
      onClick={() => setActiveSectionKey(sectionKey)}
      type="button"
    >
      {isActive && (
        <span className="t-absolute -t-left-px t-top-1 t-bottom-1 t-w-0.5 t-bg-purple-40" />
      )}
      <span className="t-flex t-items-center t-justify-between t-gap-2 t-px-2 t-py-1 t-rounded-md group-hover:t-bg-surface-grey">
        <span
          className={classNames("t-text-subtext-sm t-line-clamp-2", {
            "t-text-purple": isActive,
            "t-text-text-60": !isActive,
          })}
        >
          {children}
        </span>
        {pendingCount && <StepPendingCount {...pendingCount} />}
      </span>
    </button>
  );
};

export const FillFormStepper = ({ children }: { children: ReactNode }) => {
  return (
    <div className="t-flex t-flex-col t-gap-1 t-w-full t-border-0 t-border-l t-border-solid t-border-neutral-10">
      {children}
    </div>
  );
};

FillFormStepper.Step = Step;
